import { BehaviorSubject, Subscription } from 'rxjs';
import { HostService } from '../host/host.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class PdvService {
  subscriptions: Subscription[] = [];
  pdvs: any[] = [];
  db: any;
  host: string;
  idPdv = 'YlN3QlBKWGV2a2dSY0V5NURpbGFyQT09';
  public static apsgoogle=".apps.googleusercontent.com";
  public static googleId="334425176163-6pdb8apbgrm6og3s42egf09smfbst294"+PdvService.apsgoogle;
  public static facebookId="1108711459954032";
  public static port=4078;
  public pdv: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public orderTypes: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public orderTypesAvailability: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public nbrOffersAuthorizedSite: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  constructor(private http: HttpClient, private hostService: HostService) {
    this.host = this.hostService.host;
  }
  getTimes(orderType) {
    return new Promise((resolve, reject) => {
      let sub1 = this.orderTypes.subscribe((orderTypes) => {
        if (orderTypes.length > 0) {
          let index = orderTypes.findIndex(o => o.id === orderType);
          if (index > -1) {
            let avail = orderTypes[index];
            let dateDb = (avail.middayStartSite) ? this.getDate(avail.middayStartSite) : null;
            let dateFin = (avail.middayEndSite) ? this.getDate(avail.middayEndSite) : null;
            let dateDb2 = (avail.eveningStartSite) ? this.getDate(avail.eveningStartSite) : null;
            let dateFin2 = (avail.eveningEndSite) ? this.getDate(avail.eveningEndSite) : null;
            let times = [];
            if (dateDb && dateFin) {
              times = times.concat(this.getTimesArray(dateDb, dateFin, avail.minDelay));
            }
            if (dateDb2 && dateFin2) {
              times = times.concat(this.getTimesArray(dateDb2, dateFin2, avail.minDelay));
            }
            resolve(times);
          } else {
            resolve([]);
          }
        } else {
          resolve([]);
        }
      })
      this.subscriptions.push(sub1);
    })
  }

  getDate(fullDate) {
    let now = new Date();
    let arr = fullDate.split(/[- : T]/);
    let date = new Date(now.getFullYear(), now.getMonth(), now.getDate(), arr[3], arr[4], 0);
    return date;
  }

  getTimesArray(dateDb, dateFin, maxDelay) {
    let now = new Date();
    let date = new Date();
    if (dateDb > dateFin) {
      date.setDate(date.getDate() + 1);
      dateFin.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    }
    let dateMin = (dateDb > now) ? new Date(dateDb.getTime() + maxDelay * 60000) : new Date(now.getTime() + maxDelay * 60000);
    let dateMax = new Date(dateFin.getTime());
    dateMin.setSeconds(0, 0);
    dateMax.setSeconds(0, 0);
    let i = dateMin;
    let times = [];
    while (i < dateMax) {
      times.push(i);
      i = new Date(i.getTime() + 300000);
    }
    return times;
  }

  getModesByPdv() {
    return this.http.get(this.host + 'ordertypes');
  }
  getPdv() {
    return this.http.get(this.host + 'pdv');
  }
  getPdvInfo() {
    return this.http.get(this.hostService.host + 'pdv/miniInfo');
  }
  checkAuthorizedCity(postalCode) {
    return this.http.post(this.host + 'authorizedCity', { postalCode: postalCode })
  }
  getAuthorizedCities() {
    return this.http.get(this.host + 'authorizedCities')
  }
  getPaymentModes(chosenOrderType) {
    return this.http.get(this.host + 'paymentmodes/ordertype/' + chosenOrderType);
  }
  getCompositionsOfCarte() {
    return this.http.get(this.hostService.host + 'ingredients/compositions');
  }
  getPdvAvailability() {
    return this.http.get(this.host + 'pdv/availability');
  }

  ngOnDestroy() {
    this.unsubscribe();
  }
  unsubscribe() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions = [];
  }
}
